import { formatChartAxisLabel } from "./utils/format";

export const TOTAL_CRYPTO_BALANCE = 4394.0;
export const ASSET_COUNT = 16;

export const TIME_RANGES = ["24H", "7D", "1M", "3M", "YTD", "1Y", "MAX"];

export const BALANCE_CHART = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  values: [3200, 3450, 3100, 3600, 3750, 4100, 4394],
};

export const FIAT_ACCOUNTS = [
  {
    id: "usd",
    currency: "USD",
    name: "USD  Account",
    accountNumber: "145500756823",
    balanceLabel: "USD 993.22",
    logo: "https://flagcdn.com/w80/us.png",
    iconBg: "#fff7eb",
  },
  {
    id: "eur",
    currency: "EUR",
    name: "EUR  Account",
    accountNumber: "145500756825",
    balanceLabel: "EUR 1,000.00",
    logo: "https://flagcdn.com/w80/eu.png",
    iconBg: "#eaf7f2",
  },
  {
    id: "aed",
    currency: "AED",
    name: "AED  Account",
    accountNumber: "145500756829",
    balanceLabel: "AED 100.01",
    logo: "https://flagcdn.com/w80/ae.png",
    iconBg: "#f7f7f5",
  },
];

export const SWAP_TRENDING_PAIRS = [
  {
    id: "btc-usdt",
    symbol: "BTC",
    pair: "USDT",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
  },
  {
    id: "usdc-usdt",
    symbol: "USDC",
    pair: "USDT",
    logo: "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
    iconBg: "#eef0fd",
  },
  {
    id: "eth-usdt",
    symbol: "ETH",
    pair: "USDT",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    iconBg: "#eef0fd",
  },
];

export const BUY_STEPS = [
  { id: 1, label: "Select Fiat Account" },
  { id: 2, label: "Select Asset" },
  { id: 3, label: "Enter Amount" },
  { id: 4, label: "Confirm Order" },
];

export const SELL_STEPS = [
  { id: 1, label: "Select Account" },
  { id: 2, label: "Select Destination Account" },
  { id: 3, label: "Enter Amount" },
  { id: 4, label: "Confirm Order" },
];

export const BUY_SELL_STEPS = BUY_STEPS;

export const TRANSFER_DEPOSIT_STEPS = [
  { id: 1, label: "Select Asset" },
  { id: 2, label: "Confirm Asset" },
  { id: 3, label: "Deposit Address" },
];

export const TRANSFER_WITHDRAW_STEPS = [
  { id: 1, label: "Select Asset" },
  { id: 2, label: "Enter Details" },
  { id: 3, label: "Confirm Order" },
];

export const WITHDRAW_BENEFICIARIES = [
  { id: "b1", name: "Beneficiary 1", type: "Business" },
  { id: "b2", name: "Beneficiary 2", type: "Individual" },
  { id: "b3", name: "Beneficiary 3", type: "Business" },
  { id: "b4", name: "Beneficiary 4", type: "Individual" },
];

export const BENEFICIARY_TYPE_OPTIONS = ["Business", "Individual"];

export const WALLET_TYPE_OPTIONS = [
  "Custodial (Exchange/Third-party)",
  "Self-custodial",
];

export const BENEFICIARY_NETWORK_OPTIONS = [
  { id: "erc20", label: "ERC20" },
  { id: "trc20", label: "TRC20" },
  { id: "bep20", label: "BEP20" },
  { id: "btc", label: "Bitcoin" },
  { id: "ltc", label: "Litecoin" },
];

export const WITHDRAW_NETWORKS = [
  { id: "base", symbol: "BASE", name: "Base" },
  { id: "eth", symbol: "ETH", name: "Ethereum (ERC20)" },
  { id: "trx", symbol: "TRX", name: "Tron (TRC20)" },
  { id: "arb", symbol: "ARB", name: "Arbitrum One" },
];

export const MOCK_DEPOSIT_ADDRESS =
  "0x8304Fd4e8EF2855506440DcB07547971D89c4d3D";

export const DEPOSIT_NETWORKS = [
  {
    id: "bsc",
    symbol: "BSC",
    name: "Scroll",
    chainLabel: "BPC1 Scroll Chain",
    contractInfo: "Contract Information ***97955",
    blockConfirmations: 5,
    minimumDeposit: ">0.01 USDT",
    estimatedArrival: "≈ 1 mins",
  },
  {
    id: "trx",
    symbol: "TRX",
    name: "Tron (TRC20)",
    chainLabel: "TRC20 Tron Chain",
    contractInfo: "Contract Information ***42108",
    blockConfirmations: 1,
    minimumDeposit: ">0.01 USDT",
    estimatedArrival: "≈ 1 mins",
  },
  {
    id: "apt",
    symbol: "APT",
    name: "Aptos",
    chainLabel: "APT Aptos Chain",
    contractInfo: "Contract Information ***31842",
    blockConfirmations: 1,
    minimumDeposit: ">0.000001 USDT",
    estimatedArrival: "≈ 1 mins",
  },
  {
    id: "eth",
    symbol: "ETH",
    name: "Ethereum (ERC20)",
    chainLabel: "ERC20 Ethereum Chain",
    contractInfo: "Contract Information ***60231",
    blockConfirmations: 12,
    minimumDeposit: ">0.01 USDT",
    estimatedArrival: "≈ 3 mins",
  },
  {
    id: "arb",
    symbol: "ARB",
    name: "Arbitrum One",
    chainLabel: "ARB Arbitrum Chain",
    contractInfo: "Contract Information ***77419",
    blockConfirmations: 20,
    minimumDeposit: ">0.01 USDT",
    estimatedArrival: "≈ 2 mins",
  },
  {
    id: "sol",
    symbol: "SOL",
    name: "Solana (SPL)",
    chainLabel: "SPL Solana Chain",
    contractInfo: "Contract Information ***90563",
    blockConfirmations: 1,
    minimumDeposit: ">0.01 USDT",
    estimatedArrival: "≈ 1 mins",
  },
  {
    id: "btc",
    symbol: "BTC",
    name: "Bitcoin",
    chainLabel: "BPC1 Bitcoin Chain",
    contractInfo: "Contract Information ***97955",
    blockConfirmations: 3,
    minimumDeposit: ">0.0001 BTC",
    estimatedArrival: "≈ 10 mins",
  },
];

export const TRENDING_ASSETS = [
  {
    id: "btc",
    symbol: "BTC",
    name: "Bitcoin",
    valueLabel: "$82,423.94",
    change24h: 0.46,
    positive: true,
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
    unitPriceUsd: 82423.94,
    balanceLabel: "0.042 BTC",
  },
  {
    id: "usdt",
    symbol: "USDT",
    name: "TetherUS",
    valueLabel: "$2,409.48",
    change24h: 0.46,
    positive: true,
    logo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    iconBg: "#eaf7f2",
    unitPriceUsd: 1,
    balanceLabel: "120.00 USDT",
  },
  {
    id: "eth",
    symbol: "ETH",
    name: "Etherium",
    valueLabel: "0.85 ETH",
    change24h: 2.06,
    positive: false,
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    iconBg: "#eef0fd",
    unitPriceUsd: 2800,
    balanceLabel: "0.85 ETH",
  },
  {
    id: "usdc",
    symbol: "USDC",
    name: "USDC",
    valueLabel: "0.85 USDC",
    change24h: 2.06,
    positive: true,
    logo: "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
    iconBg: "#eef0fd",
    unitPriceUsd: 1,
    balanceLabel: "0.85 USDC",
  },
  {
    id: "fdusd",
    symbol: "FDUSD",
    name: "First Digital USD",
    valueLabel: "0.26 FDUSD",
    change24h: 2.06,
    positive: true,
    logo: "https://assets.coingecko.com/coins/images/31079/small/FDUSD_icon_black.png",
    iconBg: "#eaf7f2",
    unitPriceUsd: 1,
    balanceLabel: "0.26 FDUSD",
    subValueLabel: "$0.46",
  },
];

const EXTRA_SYMBOL_PRICES = {
  SOL: 1.77,
  DOT: 5.2,
  LTC: 85,
  MATIC: 0.45,
  XRP: 0.55,
};

export const getUnitPriceUsd = (symbol) =>
  TRENDING_ASSETS.find((asset) => asset.symbol === symbol)?.unitPriceUsd ??
  EXTRA_SYMBOL_PRICES[symbol] ??
  1;

const ACCOUNT_LOGOS = {
  usdt: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
  btc: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
  eth: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
  sol: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
  dot: "https://assets.coingecko.com/coins/images/12171/small/polkadot.png",
  ltc: "https://assets.coingecko.com/coins/images/2/small/litecoin.png",
  matic: "https://assets.coingecko.com/coins/images/4713/small/polygon.png",
  xrp: "https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png",
};

export const ALL_YOUR_ACCOUNTS = [
  {
    id: "usdt-erc20",
    symbol: "USDT",
    name: "Tether",
    network: "ERC20",
    networkLabel: "ERC20",
    walletAddress: "0xE436c...E9812",
    logo: ACCOUNT_LOGOS.usdt,
    iconBg: "#eaf7f2",
    amountLabel: "1000.02 USDT",
    usdLabel: "$1000.00",
    change24h: 0.46,
    positive: true,
  },
  {
    id: "usdt-sol",
    symbol: "USDT",
    name: "Tether",
    network: "SOL",
    networkLabel: "SOL",
    walletAddress: "0x8e36c...E9812",
    logo: ACCOUNT_LOGOS.usdt,
    iconBg: "#eaf7f2",
    amountLabel: "1000.02 USDT",
    usdLabel: "$1000.00",
    change24h: 0.46,
    positive: true,
  },
  {
    id: "usdt-bep20",
    symbol: "USDT",
    name: "Tether",
    network: "BEP20",
    networkLabel: "BEP20",
    walletAddress: "0xR436c...E9812",
    logo: ACCOUNT_LOGOS.usdt,
    iconBg: "#eaf7f2",
    amountLabel: "1000.02 USDT",
    usdLabel: "$1000.02",
    change24h: 0.46,
    positive: true,
  },
  {
    id: "btc-erc20",
    symbol: "BTC",
    name: "Bitcoin",
    network: "ERC20",
    walletAddress: "bc1q2fj...5qjfe",
    logo: ACCOUNT_LOGOS.btc,
    iconBg: "#fff7eb",
    amountLabel: "0.042 BTC",
    usdLabel: "$2,840.00",
    change24h: 0.22,
    positive: true,
  },
  {
    id: "eth-erc20",
    symbol: "ETH",
    name: "Etherium",
    network: "ERC20",
    walletAddress: "0xE436c...E9812",
    logo: ACCOUNT_LOGOS.eth,
    iconBg: "#eef0fd",
    amountLabel: "0.85 ETH",
    usdLabel: "$1,612.00",
    change24h: 0.12,
    positive: false,
  },
  {
    id: "sol-erc20",
    symbol: "SOL",
    name: "Solana",
    network: "ERC20",
    walletAddress: "9pfpY.....Gwe3b",
    logo: ACCOUNT_LOGOS.sol,
    amountLabel: "0.26 SOL",
    usdLabel: "$0.4612312",
    change24h: 0.31,
    positive: false,
  },
  {
    id: "dot-erc20",
    symbol: "DOT",
    name: "Polkadot",
    network: "ERC20",
    walletAddress: "9pfpY.....Gwe3b",
    logo: ACCOUNT_LOGOS.dot,
    amountLabel: "0.26 DOT",
    usdLabel: "$0.4612312",
    change24h: 0.31,
    positive: false,
  },
  {
    id: "cos-erc20",
    symbol: "COS",
    name: "Contentos",
    network: "ERC20",
    walletAddress: "9pfpY.....Gwe3b",
    logo: ACCOUNT_LOGOS.matic,
    amountLabel: "0.26 COS",
    usdLabel: "$0.4612312",
    change24h: 0.31,
    positive: false,
  },
  {
    id: "ltc-erc20",
    symbol: "LTC",
    name: "Litecoin",
    network: "ERC20",
    walletAddress: "9pfpY.....Gwe3b",
    logo: ACCOUNT_LOGOS.ltc,
    amountLabel: "0.26 LTC",
    usdLabel: "$0.4612312",
    change24h: 0.31,
    positive: false,
  },
  {
    id: "sol-erc20-2",
    symbol: "SOL",
    name: "Solana",
    network: "ERC20",
    walletAddress: "9pfpY.....Gwe3b",
    logo: ACCOUNT_LOGOS.sol,
    amountLabel: "0.26 SOL",
    usdLabel: "$0.4612312",
    change24h: 0.31,
    positive: false,
  },
  {
    id: "usdt-trc20",
    symbol: "USDT",
    name: "Tether",
    network: "TRC20",
    networkLabel: "TRC20",
    walletAddress: "TXyz9k...4mP2q",
    logo: ACCOUNT_LOGOS.usdt,
    iconBg: "#eaf7f2",
    amountLabel: "120.00 USDT",
    usdLabel: "$120.00",
    change24h: 0.08,
    positive: true,
  },
  {
    id: "btc-native",
    symbol: "BTC",
    name: "Bitcoin",
    network: "Native",
    walletAddress: "bc1q8xk...9aF3d",
    logo: ACCOUNT_LOGOS.btc,
    iconBg: "#fff7eb",
    amountLabel: "0.015 BTC",
    usdLabel: "$1,012.50",
    change24h: 0.18,
    positive: true,
  },
  {
    id: "eth-arb",
    symbol: "ETH",
    name: "Etherium",
    network: "Arbitrum",
    walletAddress: "0xAb12c...9F4e1",
    logo: ACCOUNT_LOGOS.eth,
    iconBg: "#eef0fd",
    amountLabel: "0.42 ETH",
    usdLabel: "$796.80",
    change24h: 0.05,
    positive: false,
  },
  {
    id: "matic-erc20",
    symbol: "MATIC",
    name: "Polygon",
    network: "ERC20",
    walletAddress: "0xE436c...E9812",
    logo: ACCOUNT_LOGOS.matic,
    iconBg: "#eef0fd",
    amountLabel: "450.00 MATIC",
    usdLabel: "$382.50",
    change24h: 0.14,
    positive: true,
  },
  {
    id: "xrp-native",
    symbol: "XRP",
    name: "Ripple",
    network: "Native",
    walletAddress: "rN7n8o...kL9mN",
    logo: ACCOUNT_LOGOS.xrp,
    amountLabel: "1,200.00 XRP",
    usdLabel: "$624.00",
    change24h: 0.09,
    positive: true,
  },
  {
    id: "sol-spl",
    symbol: "SOL",
    name: "Solana",
    network: "SPL",
    walletAddress: "7xKXt2...pQ8rS",
    logo: ACCOUNT_LOGOS.sol,
    amountLabel: "1.50 SOL",
    usdLabel: "$134.16",
    change24h: 0.27,
    positive: false,
  },
  {
    id: "dot-native",
    symbol: "DOT",
    name: "Polkadot",
    network: "Native",
    walletAddress: "15oF4...gH7jK",
    logo: ACCOUNT_LOGOS.dot,
    amountLabel: "88.00 DOT",
    usdLabel: "$352.00",
    change24h: 0.11,
    positive: false,
  },
  {
    id: "ltc-native",
    symbol: "LTC",
    name: "Litecoin",
    network: "Native",
    walletAddress: "ltc1q9...vW2xY",
    logo: ACCOUNT_LOGOS.ltc,
    amountLabel: "3.20 LTC",
    usdLabel: "$288.00",
    change24h: 0.19,
    positive: true,
  },
];

export const YOUR_ACCOUNTS = ALL_YOUR_ACCOUNTS.slice(0, 5);

const SPARKLINE_UP = [
  50, 47, 51, 46, 52, 45, 42, 40, 58, 75, 70, 80, 74, 84, 78, 88, 82, 90, 84,
  87,
];

const mirrorSparkline = (points) => {
  const min = Math.min(...points);
  const max = Math.max(...points);
  return points.map((value) => max + min - value);
};

const SPARKLINE_DOWN = mirrorSparkline(SPARKLINE_UP);

const MARKET_PRICE_ENTRIES = [
  {
    id: "btc",
    rank: 1,
    name: "Bitcoin",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
    price: 82423.94,
    change1h: 0.43,
    change1hPositive: false,
    change24h: 0.16,
    positive: false,
    change7d: 0.12,
    change7dPositive: true,
    marketCap: 1619573008939,
    volumeUsd: 12456789012,
    volumeLabel: "234.56K",
    color: "#F7931A",
  },
  {
    id: "eth",
    rank: 2,
    name: "Ethereum",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    iconBg: "#eef0fd",
    price: 2409.48,
    change1h: 0.33,
    change1hPositive: true,
    change24h: 0.27,
    positive: true,
    change7d: 2.06,
    change7dPositive: true,
    marketCap: 281671908093,
    volumeUsd: 45678901234,
    volumeLabel: "567.89K",
    color: "#627EEA",
  },
  {
    id: "sol",
    rank: 3,
    name: "Solana",
    logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    iconBg: "#eaf7f2",
    price: 89.44,
    change1h: 0.46,
    change1hPositive: true,
    change24h: 0.46,
    positive: true,
    change7d: 0.46,
    change7dPositive: true,
    marketCap: 42156789012,
    volumeUsd: 3456789012,
    volumeLabel: "123.45K",
    color: "#14F195",
  },
  {
    id: "dot",
    rank: 4,
    name: "Polkadot",
    logo: "https://assets.coingecko.com/coins/images/12171/small/polkadot.png",
    iconBg: "#eaf7f2",
    price: 1.33,
    change1h: 0.46,
    change1hPositive: true,
    change24h: 0.46,
    positive: true,
    change7d: 0.46,
    change7dPositive: true,
    marketCap: 20156789012,
    volumeUsd: 2456789012,
    volumeLabel: "98.12K",
    color: "#E6007A",
  },
  {
    id: "pepe",
    rank: 5,
    name: "Pepe",
    logo: "https://assets.coingecko.com/coins/images/29850/small/pepe-token.jpeg",
    iconBg: "#eaf7f2",
    price: 0.05,
    change1h: 0.46,
    change1hPositive: true,
    change24h: 0.46,
    positive: true,
    change7d: 0.46,
    change7dPositive: true,
    marketCap: 5156789012,
    volumeUsd: 1456789012,
    volumeLabel: "45.67K",
    color: "#3D9E4F",
  },
  {
    id: "atom",
    rank: 6,
    name: "Cosmos",
    logo: "https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png",
    iconBg: "#eaf7f2",
    price: 1.95,
    change1h: 0.48,
    change1hPositive: false,
    change24h: 0.48,
    positive: false,
    change7d: 0.48,
    change7dPositive: false,
    marketCap: 8156789012,
    volumeUsd: 956789012,
    volumeLabel: "32.10K",
    color: "#6B7A65",
  },
  {
    id: "ltc",
    rank: 7,
    name: "Litecoin",
    logo: "https://assets.coingecko.com/coins/images/2/small/litecoin.png",
    iconBg: "#eaf7f2",
    price: 57.74,
    change1h: 0.46,
    change1hPositive: true,
    change24h: 0.46,
    positive: true,
    change7d: 0.46,
    change7dPositive: true,
    marketCap: 4315678901,
    volumeUsd: 856789012,
    volumeLabel: "28.44K",
    color: "#345D9D",
  },
  {
    id: "xlm",
    rank: 8,
    name: "Stellar Lumens",
    logo: "https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png",
    iconBg: "#eaf7f2",
    price: 0.1655,
    change1h: 0.67,
    change1hPositive: false,
    change24h: 0.67,
    positive: false,
    change7d: 0.67,
    change7dPositive: false,
    marketCap: 5156789012,
    volumeUsd: 456789012,
    volumeLabel: "12.34K",
    color: "#6B7A65",
  },
];

export const MARKET_STATS = {
  marketCap: { value: "$2.7T", change: 0.17, positive: true },
  volume24h: { value: "55.7", thumbLeft: 148, thumbPercent: 0.53 },
  btcDominance: { value: "51.3%", change: 2.4, positive: true },
  fearGreed: { value: 50, label: "Neutral" },
};

const ASSET_SYMBOLS = {
  btc: "BTC",
  eth: "ETH",
  sol: "SOL",
  dot: "DOT",
  pepe: "PEPE",
  atom: "ATOM",
  ltc: "LTC",
  xlm: "XLM",
};

const CHART_RANGE_CONFIG = {
  "24H": {
    pointCount: 96,
    labels: [
      "4.00PM",
      "6.00PM",
      "8.00PM",
      "10.00PM",
      "11 May",
      "2.00AM",
      "4.00AM",
      "6.00AM",
      "8.00AM",
      "10.00AM",
    ],
    rangePercent: 0.2,
    trendBias: -0.35,
    tooltip: { date: "05/10/2026", time: "9:40:00 PM" },
    volume: "$17.75B",
  },
  "7D": {
    pointCount: 84,
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    rangePercent: 0.26,
    trendBias: -0.12,
    tooltip: { date: "06/08/2026", time: "12:00:00 PM" },
    volume: "$98.42B",
  },
  "1M": {
    pointCount: 90,
    labels: ["May 9", "May 14", "May 19", "May 24", "May 29", "Jun 3", "Jun 8"],
    rangePercent: 0.32,
    trendBias: 0.08,
    tooltip: { date: "06/08/2026", time: "12:00:00 AM" },
    volume: "$412.6B",
  },
  "3M": {
    pointCount: 72,
    labels: ["Mar", "Mar 20", "Apr 10", "May 1", "May 20", "Jun 8"],
    rangePercent: 0.38,
    trendBias: 0.15,
    tooltip: { date: "06/08/2026", time: "12:00:00 AM" },
    volume: "$1.12T",
  },
  YTD: {
    pointCount: 60,
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    rangePercent: 0.45,
    trendBias: 0.22,
    tooltip: { date: "06/08/2026", time: "12:00:00 AM" },
    volume: "$2.41T",
  },
  "1Y": {
    pointCount: 72,
    labels: ["Jul", "Sep", "Nov", "Jan", "Mar", "May"],
    rangePercent: 0.5,
    trendBias: 0.28,
    tooltip: { date: "05/10/2026", time: "9:40:00 PM" },
    volume: "$17.75B",
  },
  MAX: {
    pointCount: 96,
    labels: ["2018", "2019", "2020", "2022", "2024", "2026"],
    rangePercent: 0.65,
    trendBias: 0.55,
    tooltip: { date: "06/08/2026", time: "12:00:00 AM" },
    volume: "$4.88T",
  },
};

const chartSeed = (timeRange) =>
  timeRange.charCodeAt(0) * 0.17 + (timeRange.charCodeAt(1) || 0) * 0.09;

const niceStep = (rawStep, basePrice) => {
  if (rawStep <= 0) {
    if (basePrice >= 1e9) return 1e8;
    if (basePrice >= 1e6) return 1e5;
    if (basePrice >= 10000) return 1000;
    if (basePrice >= 1000) return 100;
    if (basePrice >= 1) return 0.1;
    return 0.001;
  }

  const magnitude = 10 ** Math.floor(Math.log10(rawStep));
  const residual = rawStep / magnitude;

  if (residual <= 1.5) return magnitude;
  if (residual <= 3.5) return 2 * magnitude;
  if (residual <= 7.5) return 5 * magnitude;
  return 10 * magnitude;
};

const getChartYAxisFromValues = (values, basePrice) => {
  const dataMin = Math.min(...values);
  const dataMax = Math.max(...values);
  const spread = dataMax - dataMin || basePrice * 0.08;
  const padding = Math.max(spread * 0.08, basePrice * 0.005);

  let step = niceStep((dataMax - dataMin + padding * 2) / 3, basePrice);
  let bottom = 0;
  let top = 0;

  do {
    bottom = Math.floor((dataMin - padding) / step) * step;
    top = bottom + step * 3;

    if (dataMax > top || dataMin < bottom) {
      const nextStep = niceStep(step * 1.25, basePrice);
      step = nextStep > step ? nextStep : step * 2;
    }
  } while (dataMax > top || dataMin < bottom);

  return {
    yLabels: Array.from({ length: 4 }, (_, i) =>
      formatChartAxisLabel(top - i * step),
    ),
    min: bottom,
    max: top,
  };
};

const getChartLabelIndices = (pointCount, labelCount) =>
  Array.from({ length: labelCount }, (_, i) =>
    Math.round((i / Math.max(labelCount - 1, 1)) * (pointCount - 1)),
  );

const generateChartSeries = (
  count,
  basePrice,
  timeRange,
  { rangePercent, trendBias },
) => {
  const seed = chartSeed(timeRange);
  const startMult = 1 + rangePercent * (trendBias < 0 ? 0.42 : -0.28);
  const endMult = 1 + rangePercent * (trendBias < 0 ? -0.38 : 0.48);

  return Array.from({ length: count }, (_, i) => {
    const t = i / Math.max(count - 1, 1);
    const trend = startMult + (endMult - startMult) * t;
    const wave1 = Math.sin(t * Math.PI * 2.6 + seed) * rangePercent * 0.34;
    const wave2 =
      Math.sin(t * Math.PI * 5.2 + seed * 1.4) * rangePercent * 0.14;
    const wave3 = Math.sin(t * Math.PI * 11 + seed * 2.1) * rangePercent * 0.07;
    const price = basePrice * (trend + wave1 + wave2 + wave3);

    return Math.round(price * 100) / 100;
  });
};

const generateChartVolumes = (count, timeRange, values) => {
  const seed = chartSeed(timeRange);

  return Array.from({ length: count }, (_, i) => {
    const t = i / Math.max(count - 1, 1);
    const base = 14 + (timeRange.length % 3) * 5;
    const cycle = 12 + Math.sin(t * Math.PI * 2.4 + seed) * 10;
    const burst = Math.sin(t * Math.PI * 8 + seed * 1.7) > 0.78 ? 24 : 0;
    const morningSpike =
      t > 0.42 && t < 0.52 && Math.sin(seed * 5) > -0.2 ? 34 : 0;
    const moveBoost =
      i > 0 ? Math.min(Math.abs(values[i] - values[i - 1]) / 120, 1) * 16 : 0;

    return Math.round(base + cycle + burst + morningSpike + moveBoost);
  });
};

export const getAssetDetailChart = (timeRange, basePrice) => {
  const config = CHART_RANGE_CONFIG[timeRange] ?? CHART_RANGE_CONFIG["1Y"];
  const values = generateChartSeries(
    config.pointCount,
    basePrice,
    timeRange,
    config,
  );
  const yAxis = getChartYAxisFromValues(values, basePrice);
  const midIndex = Math.floor(values.length * 0.55);

  return {
    values,
    volumes: generateChartVolumes(config.pointCount, timeRange, values),
    labels: config.labels,
    labelIndices: getChartLabelIndices(config.pointCount, config.labels.length),
    yLabels: yAxis.yLabels,
    yDomain: { min: yAxis.min, max: yAxis.max },
    tooltip: {
      ...config.tooltip,
      price: values[midIndex],
      volume: config.volume,
    },
  };
};

export const ASSET_DETAIL_CHART = getAssetDetailChart("1Y", 80839.06);

export const getModalAssetTransactions = (symbol, logo, iconBg) => [
  {
    id: `${symbol}-tx-1`,
    logo,
    title: `Withdrew ${symbol}`,
    date: "April 13, 2026",
    primaryAmount: "-23.78 USDC",
    primaryPositive: false,
    secondaryAmount: "-$9.49",
  },
  {
    id: `${symbol}-tx-2`,
    logo,
    title: `Deposited ${symbol}`,
    date: "April 13, 2026",
    primaryAmount: `+0.034 ${symbol}`,
    primaryPositive: true,
    secondaryAmount: "+$894.01 USDT",
  },
  {
    id: `${symbol}-tx-3`,
    logo,
    title: `Sold ${symbol}`,
    date: "April 13, 2026",
    primaryAmount: `+1,500.12 ${symbol}`,
    primaryPositive: true,
    secondaryAmount: `-0.02 ${symbol}`,
    secondaryMedium: true,
  },
  {
    id: `${symbol}-tx-4`,
    logo,
    iconBg: iconBg || "#fff7eb",
    title: `Bought ${symbol}`,
    date: "April 20, 2026",
    primaryAmount: `+0.02 ${symbol}`,
    primaryPositive: true,
    secondaryAmount: "- 1,500.12 USDT",
    secondaryMedium: true,
  },
  {
    id: `${symbol}-tx-5`,
    logo,
    iconBg: iconBg || "#fff7eb",
    title: `Bought ${symbol}`,
    date: "April 20, 2026",
    primaryAmount: `+0.02 ${symbol}`,
    primaryPositive: true,
    secondaryAmount: "- 1,500.12 USDT",
    secondaryMedium: true,
  },
];

export const MARKET_PRICES = MARKET_PRICE_ENTRIES.map((entry) => ({
  ...entry,
  symbol: ASSET_SYMBOLS[entry.id] ?? entry.name.slice(0, 3).toUpperCase(),
  sparkline: entry.positive ? SPARKLINE_UP : SPARKLINE_DOWN,
}));

export const CRYPTO_NEWS = [
  {
    id: "coindesk",
    source: "Coindesk News",
    headline: "Bitcoin ETFs See Record Institutio...",
    dotColor: "#3B82F6",
  },
  {
    id: "cointelegraph",
    source: "CoinTelegraph",
    headline: "Ethereum Layer-2 Activity Surges...",
    dotColor: "#F59E0B",
  },
  {
    id: "the-block",
    source: "The Block News",
    headline: "Solana Ecosystem Expands With...",
    dotColor: "#EF4444",
  },
  {
    id: "qed",
    source: "QED News",
    headline: "Avalanche Integrates AI for Enhanced S...",
    dotColor: "#8B5CF6",
  },
];

export const RECENT_TRANSACTIONS = [
  {
    id: "tx-1",
    logo: "https://assets.coingecko.com/coins/images/6319/small/usdc.png",
    title: "Withdrew USDC for USD",
    date: "April 13, 2026",
    primaryAmount: "-23.78 USDC",
    primaryPositive: false,
    secondaryAmount: "-$9.49",
  },
  {
    id: "tx-2",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    title: "Deposited ETH for USDT",
    date: "April 13, 2026",
    primaryAmount: "+0.034 ETH",
    primaryPositive: true,
    secondaryAmount: "+$894.01 USDT",
  },
  {
    id: "tx-3",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    title: "Sold BTC for USDT",
    date: "April 13, 2026",
    primaryAmount: "+1,500.12 USDT",
    primaryPositive: true,
    secondaryAmount: "-0.02 BTC",
    secondaryMedium: true,
  },
  {
    id: "tx-4",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
    title: "Bought BTC for USDT",
    date: "April 20, 2026",
    primaryAmount: "+0.02 BTC",
    primaryPositive: true,
    secondaryAmount: "- 1,500.12 USDT",
    secondaryMedium: true,
  },
  {
    id: "tx-5",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
    title: "Bought BTC for USDT",
    date: "April 20, 2026",
    primaryAmount: "+0.02 BTC",
    primaryPositive: true,
    secondaryAmount: "- 1,500.12 USDT",
    secondaryMedium: true,
  },
];

export const TRANSACTION_ASSET_OPTIONS = [
  {
    id: "usdt",
    symbol: "USDT",
    logo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    iconBg: "#eaf7f2",
  },
  {
    id: "btc",
    symbol: "BTC",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
  },
  {
    id: "eth",
    symbol: "ETH",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
  },
  {
    id: "sol",
    symbol: "SOL",
    logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
  },
  {
    id: "trx",
    symbol: "TRX",
    logo: "https://assets.coingecko.com/coins/images/1094/small/tron-logo.png",
  },
];

export const TRANSACTION_TYPE_OPTIONS = [
  "All Transactions",
  "Withdrew",
  "Deposited",
  "Sold",
  "Bought",
  "Swapped",
];

export const TRANSACTION_DATE_RANGE_OPTIONS = [
  "All Time",
  "Past 24 Hours",
  "Past 7 Days",
  "This Month",
  "Previous Month",
];

export const CRYPTO_TRANSACTION_HISTORY = [
  {
    id: "tx-h-1",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    title: "Deposited ETH",
    date: "April 13, 2026",
    primaryAmount: "+0.34 ETH",
    primaryPositive: true,
    secondaryAmount: "+$112.54 USDT",
    detailTitle: "ETH Deposit",
    walletLabel: "Using ETH Wallet",
    detailAmount: "+0.034 ETH",
    detailUsd: "+$112.54 USD",
    status: "Completed",
    dateTime: "Apr 13, 2026, 09:41 AM",
    referenceCode: "H653ELSKV1",
    priceLabel: "ETH Price",
    assetPrice: "$3,310.29",
    amountLabel: "Deposited Amount",
    amount: "0.034 ETH",
    usdValue: "$112.54",
    network: "Ethereum",
    networkFee: "0.00042 ETH",
    txid: "abc...24024",
  },
  {
    id: "tx-h-2",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    title: "Sold BTC",
    date: "April 9, 2026",
    primaryAmount: "+1,482.34 USDT",
    primaryPositive: true,
    secondaryAmount: "-0.02 BTC",
    secondaryMedium: true,
    detailTitle: "BTC Sale",
    walletLabel: "Using BTC Wallet",
    detailAmount: "+1,482.34 USDT",
    detailUsd: "+$1,482.34 USD",
    status: "Completed",
    dateTime: "Apr 9, 2026, 02:15 PM",
    referenceCode: "K921PLMNX4",
    priceLabel: "BTC Price",
    assetPrice: "$74,117.00",
    amountLabel: "Sold Amount",
    amount: "0.02 BTC",
    usdValue: "$1,482.34",
    network: "Bitcoin",
    networkFee: "0.00008 BTC",
    txid: "def...89102",
  },
  {
    id: "tx-h-3",
    logo: "https://assets.coingecko.com/coins/images/1/small/bitcoin.png",
    iconBg: "#fff7eb",
    title: "Bought BTC",
    date: "April 2, 2026",
    primaryAmount: "+0.02 BTC",
    primaryPositive: true,
    secondaryAmount: "-1,527.90 USDT",
    secondaryMedium: true,
    detailTitle: "BTC Purchase",
    walletLabel: "Using USDT Wallet",
    detailAmount: "+0.02 BTC",
    detailUsd: "-$1,527.90 USD",
    status: "Completed",
    dateTime: "Apr 2, 2026, 11:08 AM",
    referenceCode: "B384QWERZ9",
    priceLabel: "BTC Price",
    assetPrice: "$76,395.00",
    amountLabel: "Purchased Amount",
    amount: "0.02 BTC",
    usdValue: "$1,527.90",
    network: "Bitcoin",
    networkFee: "0.00005 BTC",
    txid: "ghi...55231",
  },
  {
    id: "tx-h-4",
    type: "swap",
    logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    fromLogo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    toLogo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    title: "Swapped SOL",
    date: "March 29, 2026",
    primaryAmount: "+118.42 USDT",
    primaryPositive: true,
    secondaryAmount: "-0.51 SOL",
    detailTitle: "Swapped SOL",
    walletLabel: "Using SOL Wallet",
    detailAmount: "+118.42 USDT",
    swapSubtitle: "0.510 SOL Swapped",
    status: "Completed",
    dateTime: "Mar 29, 2026, 04:26 PM",
    referenceCode: "S9L2UXQW8",
    swapRate: "1 SOL = 232.19 USDT",
    fromAmountLabel: "SOL Amount",
    fromAmountValue: "0.510 SOL",
    toAmountLabel: "USDT Received",
    toAmountValue: "118.42 USDT",
    tradingFee: "1.50 USDT",
    networkFee: "0.00021 SOL",
    totalReceived: "116.92 USDT",
    priceLabel: "SOL Price",
    assetPrice: "$232.20",
    amountLabel: "Swapped Amount",
    amount: "0.51 SOL",
    usdValue: "$118.42",
    network: "Solana",
    txid: "jkl...77845",
  },
  {
    id: "tx-h-5",
    type: "swap",
    logo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    fromLogo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    toLogo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    title: "Swapped USDT",
    date: "March 24, 2026",
    primaryAmount: "+0.49 SOL",
    primaryPositive: true,
    secondaryAmount: "-126.12 USDT",
    detailTitle: "Swapped USDT",
    walletLabel: "Using USDT Wallet",
    detailAmount: "+0.49 SOL",
    swapSubtitle: "126.12 USDT Swapped",
    status: "Completed",
    dateTime: "Mar 24, 2026, 10:55 AM",
    referenceCode: "U456RSTUV7",
    swapRate: "1 SOL = 257.39 USDT",
    fromAmountLabel: "USDT Amount",
    fromAmountValue: "126.12 USDT",
    toAmountLabel: "SOL Received",
    toAmountValue: "0.49 SOL",
    tradingFee: "1.26 USDT",
    networkFee: "0.00018 SOL",
    totalReceived: "0.49 SOL",
    priceLabel: "SOL Price",
    assetPrice: "$257.39",
    amountLabel: "Swapped Amount",
    amount: "126.12 USDT",
    usdValue: "$126.12",
    network: "Solana",
    txid: "mno...33456",
  },
  {
    id: "tx-h-6",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    title: "Withdrew ETH",
    date: "March 22, 2026",
    primaryAmount: "-0.34 ETH",
    primaryPositive: false,
    secondaryAmount: "-$894.01 USDT",
    detailTitle: "ETH Withdrawal",
    walletLabel: "Using ETH Wallet",
    detailAmount: "-0.34 ETH",
    detailUsd: "-$894.01 USD",
    status: "Completed",
    dateTime: "Mar 22, 2026, 08:17 AM",
    referenceCode: "W198XYZAB3",
    priceLabel: "ETH Price",
    assetPrice: "$2,629.44",
    amountLabel: "Withdrawn Amount",
    amount: "0.34 ETH",
    usdValue: "$894.01",
    network: "Ethereum",
    networkFee: "0.00038 ETH",
    txid: "pqr...99012",
  },
  {
    id: "tx-h-7",
    type: "swap",
    logo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    fromLogo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    toLogo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    title: "Swapped SOL",
    date: "March 29, 2026",
    primaryAmount: "+118.42 USDT",
    primaryPositive: true,
    secondaryAmount: "-0.51 SOL",
    detailTitle: "Swapped SOL",
    walletLabel: "Using SOL Wallet",
    detailAmount: "+118.42 USDT",
    swapSubtitle: "0.510 SOL Swapped",
    status: "Completed",
    dateTime: "Mar 29, 2026, 04:26 PM",
    referenceCode: "S712MNOPQ3",
    swapRate: "1 SOL = 232.19 USDT",
    fromAmountLabel: "SOL Amount",
    fromAmountValue: "0.510 SOL",
    toAmountLabel: "USDT Received",
    toAmountValue: "118.42 USDT",
    tradingFee: "1.50 USDT",
    networkFee: "0.00021 SOL",
    totalReceived: "116.92 USDT",
    priceLabel: "SOL Price",
    assetPrice: "$232.20",
    amountLabel: "Swapped Amount",
    amount: "0.51 SOL",
    usdValue: "$118.42",
    network: "Solana",
    txid: "stu...11223",
  },
  {
    id: "tx-h-8",
    type: "swap",
    logo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    fromLogo: "https://assets.coingecko.com/coins/images/325/small/Tether.png",
    toLogo: "https://assets.coingecko.com/coins/images/4128/small/solana.png",
    title: "Swapped USDT",
    date: "March 24, 2026",
    primaryAmount: "+0.49 SOL",
    primaryPositive: true,
    secondaryAmount: "-126.12 USDT",
    detailTitle: "Swapped USDT",
    walletLabel: "Using USDT Wallet",
    detailAmount: "+0.49 SOL",
    swapSubtitle: "126.12 USDT Swapped",
    status: "Completed",
    dateTime: "Mar 24, 2026, 10:55 AM",
    referenceCode: "U456RSTUV8",
    swapRate: "1 SOL = 257.39 USDT",
    fromAmountLabel: "USDT Amount",
    fromAmountValue: "126.12 USDT",
    toAmountLabel: "SOL Received",
    toAmountValue: "0.49 SOL",
    tradingFee: "1.26 USDT",
    networkFee: "0.00018 SOL",
    totalReceived: "0.49 SOL",
    priceLabel: "SOL Price",
    assetPrice: "$257.39",
    amountLabel: "Swapped Amount",
    amount: "126.12 USDT",
    usdValue: "$126.12",
    network: "Solana",
    txid: "vwx...44556",
  },
  {
    id: "tx-h-9",
    logo: "https://assets.coingecko.com/coins/images/279/small/ethereum.png",
    title: "Withdrew ETH",
    date: "March 22, 2026",
    primaryAmount: "-0.34 ETH",
    primaryPositive: false,
    secondaryAmount: "-$894.01 USDT",
    detailTitle: "ETH Withdrawal",
    walletLabel: "Using ETH Wallet",
    detailAmount: "-0.34 ETH",
    detailUsd: "-$894.01 USD",
    status: "Completed",
    dateTime: "Mar 22, 2026, 08:17 AM",
    referenceCode: "W198XYZAB4",
    priceLabel: "ETH Price",
    assetPrice: "$2,629.44",
    amountLabel: "Withdrawn Amount",
    amount: "0.34 ETH",
    usdValue: "$894.01",
    network: "Ethereum",
    networkFee: "0.00038 ETH",
    txid: "yz1...66789",
  },
];

export const CRYPTO_BENEFICIARIES = [
  {
    id: "lila-carter",
    name: "Lila Carter",
    kind: "crypto",
    listLabel: "0xA9F3d...B4C21 | BTC",
    beneficiaryType: "Business",
    walletType: "Custodial (Exchange/Third-party)",
    walletAddress: "0xE436cA9F3dB4C21E9812",
    network: "ERC20",
    selfOwned: "Yes",
    symbol: "BTC",
  },
  {
    id: "jasper-lee",
    name: "Jasper Lee",
    kind: "crypto",
    listLabel: "0x7C2B9...D8E34 | LTC",
    beneficiaryType: "Individual",
    walletType: "Self-custodial",
    walletAddress: "0x7C2B9a1D4E8F34C2D8E34",
    network: "LTC",
    selfOwned: "Yes",
    symbol: "LTC",
  },
  {
    id: "sophie-tran",
    name: "Sophie Tran",
    kind: "crypto",
    listLabel: "0x5D1E7...F9A88 | ETH",
    beneficiaryType: "Business",
    walletType: "Custodial (Exchange/Third-party)",
    walletAddress: "0x5D1E7b3C9F9A88E1F2A45",
    network: "ERC20",
    selfOwned: "No",
    symbol: "ETH",
  },
  {
    id: "ethan-patel",
    name: "Ethan Patel",
    kind: "crypto",
    listLabel: "0x3B7F2...C1D45 | DOGE",
    beneficiaryType: "Individual",
    walletType: "Self-custodial",
    walletAddress: "0x3B7F2a8E1C1D45B9F0E12",
    network: "DOGE",
    selfOwned: "Yes",
    symbol: "DOGE",
  },
  {
    id: "isabella-gomez",
    name: "Isabella Gomez",
    kind: "crypto",
    listLabel: "0x8E4A1...E2B67 | XRP",
    beneficiaryType: "Business",
    walletType: "Custodial (Exchange/Third-party)",
    walletAddress: "0x8E4A1c7D2E2B67A4F8C91",
    network: "XRP",
    selfOwned: "No",
    symbol: "XRP",
  },
  {
    id: "oliver-brown",
    name: "Oliver Brown",
    kind: "crypto",
    listLabel: "0x7C2B9...D8E34 | LTC",
    beneficiaryType: "Individual",
    walletType: "Self-custodial",
    walletAddress: "0x7C2B9f1A2D8E34E5B6C78",
    network: "LTC",
    selfOwned: "Yes",
    symbol: "LTC",
  },
  {
    id: "ava-johnson-crypto",
    name: "Ava Johnson",
    kind: "crypto",
    listLabel: "0xF2D9C...A7E53 | ADA",
    beneficiaryType: "Individual",
    walletType: "Self-custodial",
    walletAddress: "0xF2D9C4B1A7E53D8E2F109",
    network: "ADA",
    selfOwned: "Yes",
    symbol: "ADA",
  },
  {
    id: "ava-johnson-fiat",
    name: "Ava Johnson",
    kind: "fiat",
    accountNumber: "80001305951387",
    routingNumber: "0937451",
    beneficiaryType: "Individual",
    bankName: "Chase Bank",
    accountType: "Checking",
  },
];
